import gql from 'graphql-tag';

export default gql`
  query cartTranslations {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        translations(language: enUS) {
          common {
            departingLegLabel
            returningLegLabel
          }
          loginSignUpForm {
            sessionInactivityTimeoutTitle
            sessionInactivityTimeoutMessage
            logOffButtonLabel
            stayLoggedInButtonLabel
          }
          flightSearchForm {
            toLabel
            roundTripLabel
            oneWayLabel
            seatedDescription
            inLapDescription
            searchExpandButtonLabel
            searchExpandButtonA11yLabel
          }
          cart {
            buttonText
            upliftText
            addBundleButtonText
            bonusBundleText
            totalBundleText
            noCartItemsDescription
            cartHeading
            flightInfoCartItemLabel
            bundleCartItemLabel
            travelersCartItemLabel
            hotelCartItemLabel
            hotelCheckInLabel
            hotelCheckOutLabel
            vehicleCartItemLabel
            vehiclePickUpLabel
            vehicleDropOffLabel
            flightPackageSubtotalLabel
            generalFlightDiscountAppliedLabel
            roundTripDiscountAppliedLabel
            roundTripDiscountAppliedModalContent
            overnightBadgeLabel
            travelToSymbol
            addBundleButtonLabelMobile
            addBundleButtonLabelDesktop
            cartItemEditLinkLabel
            cartItemAddLinkLabel
            promosCartSectionHeading
            promoAppliedLabel
            bogoDiscountLabel
            bogoDiscountModalContentHtml
            tripTotalLabel
            vehicleDaysLabel
            vehicleDaysPluralLabel
            flightLabel
            flightsLabel
            hotelLabel
            vehicleLabel
            bundleDescription
            bundleDescriptionListConjoinItems
            bundleDescriptionListConjoinFinalItems
            governmentFeesLabel
            airlineFeesLabel
            travelerSeatsLabel
            travelerBagsLabel
            travelerExtrasLabel
            travelerIncludedLabel
            travelerDestinationConjoinFlightCodes
            cartCheckedBagLabel
            cartCheckedBagsLabel
            cartCarryOnBagLabel
            cartTripFlexLabel
            cartPriorityAccessLabel
            travelersNoSeatSelectedItem
            cartIndividualTravelerLabel
            travelerCartItemLabel
            petInCabinCartItemLabel
            cartOnboardEntertainmentLabel
            dueTodayLabel
            dueAtHotelLabel
            dueToHotelLabelHTML
            cartEnhancedTripFlexLabelHTML
          }
          confirmationPage {
            bookedHotelRoomsCountText
            bookedHotelRoomsCountTextPlural
            bookedHotelRoomAdultCountText
            bookedHotelRoomAdultCountTextPlural
            bookedHotelRoomChildrenCountText
            bookedHotelRoomChildrenCountTextPlural
          }
          seatsPage {
            seatTypeEconomy
            seatTypeLegroomPlus
            seatTypeAllegiantExtra
            seatMapLegendExitRowLabel
          }
          stadiumPackages {
            stadiumTicketsLabel
            homeCityLabel
            versusLabel
            cartBannerLabel
            stadiumPackageLabel
            gameTicketLabel
            gameTicketsLabel
            ticketLabel
            ticketsLabel
            stadiumNoCartItemsDescription
          }
          travelAgentLoginPage {
            taLogOutLabel
            taIataNumberLabel
            taIataNumberDescription
          }
        }
      }
    }
  }
`;
